module.exports = __webpack_public_path__ + "img/pratonevoso.adf969c1.png";